import Flex from "../../../../DefaultStyles/Flex";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import React, { useState } from "react";
import PartyMailModal from "../../../Party/PartyDetail/PartyDetailShareInfo/PartyMailModal";
import { Input } from "../../../../Input/Input";
import DropDown, { OptionType } from "../../../../Filters/DropDown";

export default function AllMailView() {
  const [type, setType] = useState<OptionType>({
    value: "",
    label: "조회 타입 선택",
  });
  const [email, setEmail] = useState("");
  const [domainOption, setDomainOption] = useState<OptionType>({
    value: "",
    label: "도메인 선택",
  });
  const [emailModal, setEmailModal] = useState(false);

  const domainOptions: OptionType[] = [
    { value: "flipkart.com", label: "flipkart.com" },
  ];

  return (
    <>
      <Flex gapSize={10} style={{ marginBottom: 20 }}>
        <DropDown
          boxWidth={150}
          optionList={[
            { value: "db", label: "DB 조회" },
            { value: "mailgun", label: "메일건 조회" },
            { value: "db_domain", label: "From 도메인 조회" },
          ]}
          dropdownValue={type}
          setDropDownValue={(value) => {
            setType(value);
            setEmail("");
            setDomainOption({ value: "", label: "도메인 선택" });
          }}
        />

        {type.value === "db_domain" ? (
          <DropDown
            boxWidth={200}
            optionList={domainOptions}
            dropdownValue={domainOption}
            setDropDownValue={(value) => {
              setDomainOption(value);
              setEmail(value.value);
            }}
          />
        ) : (
          <Input
            placeholder="이메일 주소 입력"
            style={{ width: 200, backgroundColor: "white" }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={type.value === ""}
          />
        )}

        <ConfirmBtn
          btnText="이메일 조회"
          btnColor="mint"
          isDisabled={email === ""}
          btnClickEvent={() => setEmailModal(true)}
        />
      </Flex>

      {emailModal && (
        <PartyMailModal
          closeEvent={() => setEmailModal(false)}
          mailId={email}
          domain={type.value === "db_domain" ? email : undefined}
          type={type.value}
        />
      )}
    </>
  );
}
